import axios from 'axios'
// import { Loading } from 'element-ui';
import { Message } from 'element-ui'

//let baseURL = 'https://ceshi.chuoooo.cn/back';

const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: '/api',
  // 超时
  timeout: 20000,
  headers: {
       'Content-Type': 'application/json; charset=utf-8'
     }
})

// create an axios instance
// const instance = axios.create({
//     //baseURL: process.env.BASE_API, // api的base_url
//     baseURL: '/api/',
//     timeout: 5000 // request timeout
// })

// const loading =''
service.interceptors.request.use(
  // loading = Loading.service(options),
  config => {
    /* const token = window.localStorage.getItem('token')
    if (token) config.headers['Authorization'] = `Bearer ${token}` */
    return config
  },
  err => {
    return Promise.reject(err)
  }
)

service.interceptors.response.use(
  // loading.close(),
  data => {
    return data.data
  },
  err => {
    console.log(err)
    Message({
      message: err.message,
      type: 'error'
    })
    return Promise.reject(err)
  }
)

export const createAPI = (url, method, data) => {
  let config = {}
  if (method === 'get') {
    config.params = data
  } else {
    config.data = data
  }
  // console.log( config.data );return
  return service({
    url,
    method,
    ...config
  })
}

export const createFormAPI = (url, method, data) => {
  let config = {}
  config.data = data
  config.headers = {
    'Cache-Control': 'no-cache',
    'Content-Type': 'application/x-www-form-urlencoded'
  }
  config.responseType = 'json'
  config.transformRequest = [
    function (data) {
      let ret = ''
      for (let it in data) {
        ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
      }
      return ret
    }
  ]
  return service({
    url,
    method,
    ...config
  })
}
export const createImgAPI = (url, method, data) => {
  let config = {}
  config.data = data
  config.headers = {
    'Cache-Control': 'no-cache',
    'Content-Type': 'application/x-www-form-urlencoded'
  }
  config.responseType = 'blob'
  config.transformRequest = [
    function (data) {
      let ret = ''
      for (let it in data) {
        ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
      }
      return ret
    }
  ]
  return service({
    url,
    method,
    ...config
  })
}

export default service
